function ErrorViewContainer({ children }: { children: React.ReactNode }) {
  return <div className="pt-17 pb-6 pl-10 pr-10">{children}</div>
}

export default ErrorViewContainer
